import React from "react"
import { ContentHomePageHeading } from "./Content/ContentHomePageHeading"
import { ContentHomePageCategories } from "./Content/ContentHomePageCategories"
import { ContentContactPageContact } from "./Content/ContentContactPageContact"
import { translation } from "../../helper/translation"

export const PartialContactPage = () => {
    return(
        <React.Fragment>
            <ContentHomePageHeading breadcrumb={translation("contact")}/>
            <ContentHomePageCategories />
            <ContentContactPageContact />
        </React.Fragment>
    )
}